import { ButtonLink } from "@ui/ButtonLink";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Heading } from "@ui/typography/Heading";
import { Text } from "@ui/typography/Text";

export const RoadmapCard = () => {
	return (
		<HStack spacing="large">
			<div class="icon-bg">
				<MaterialSymbol symbol="lightbulb" />
			</div>
			<VStack spacing="medium">
				<VStack spacing="small">
					<Heading as="h3" weight="semi-bold">
						Shape what's next
					</Heading>
					<Text color="fg3">
						Vote on what's coming. Suggest what's missing.
					</Text>
				</VStack>
				<ButtonLink
					href="https://askgvt.canny.io"
					target="_blank"
					variant="tertiary"
					symbol={["map", "open_in_new"]}
					symbolRelativeSize="even-larger"
					symbolPosition="after"
				>
					Open roadmap
				</ButtonLink>
			</VStack>
		</HStack>
	);
};
